export default __webpack_public_path__ + "static/media/0035.ac09a876.jpg";